import {Suspense} from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {ErrorBoundary} from 'react-error-boundary';
import HomeTitleHeader from '@di-shared/features/home/HomeTitleHeader';
import DrivingContentsEu from '@di-shared/features/home/eu/driving/DrivingContents.eu';
import ConsentBannerEu from '@di-shared/features/home/eu/ConsentBanner.eu';

export interface HomeContentsEuProps {
  vin: string;
}

function HomeContentsEu({vin}: HomeContentsEuProps) {
  return (
    <div className="wrap">
      <Header
        className="header header_absolute"
        right={<HeaderCloseButton onClick={() => ccWebviewUtils.closeContent()} />}
      />

      <main
        id="content"
        className="content page_home"
      >
        <ErrorBoundary fallback={<HomeTitleHeader.Error />}>
          <Suspense fallback={<HomeTitleHeader.Loading />}>
            <HomeTitleHeader vin={vin} />
          </Suspense>
        </ErrorBoundary>
        <ConsentBannerEu />
        <Suspense fallback={<DrivingContentsEu.Loading />}>
          <DrivingContentsEu vin={vin} />
        </Suspense>
      </main>
    </div>
  );
}

export default HomeContentsEu;
